export const searchTheme = {
    title: 'テーマを探す',
    description: '分析するテーマを複数のアプローチから探すことができます。目的に応じたタブを選択してください。',
    searchFromList: 'テーマ一覧から探す',
    searchFromCompany: '企業から探す',
    searchFromTechnology: '技術から探す',
    searchFromTrends: 'テーマ動向から探す'
}
